export enum ModelStatus {
  DRAFT = 'Draft',
  REVIEW = 'Review',
  IN_PROCESS_SCALAR_USA = 'In-process ScalarUSA',
  COMPLETE = 'COMPLETE',
  FINAL = 'Final',
  WAITING = 'WAITING',
}

export type ModelSearchOption = 'current' | 'past' | 'unassigned';

export enum ValuationStatus {
  READY_FOR_ONBOARDING = 'Ready for onboarding',
  ONBOARDING_SENT = 'Onboarding sent',
  ONBOARDING_FINISHED = 'Onboarding finished',
  CLIENT_DOCS_RECEIVED = 'Client Docs received',
  CLIENT_DOCS_RECEIVED_SKIP_SUPPORT = 'Client Docs received (skip-support)',
  CLIENT_DOCS_RECEIVED_ASSIGN_INTERN = 'Client Docs received (ASSIGN INTERN)',
  MODEL_DRAFTED = 'Model drafted',
  DRAFT_PREPARED = 'Draft prepared',
  DRAFT_REVIEWED_AND_SENT = 'Draft reviewed and sent',
  CLIENT_APPROVAL_RECEIVED = 'Client Approval received',
  REPORT_IN_PROCESS = 'Report in process',
  FINAL_REPORT_UPLOADED = 'Final report uploaded',
  FINAL_SENT = 'Final Sent',
  WAITING = 'WAITING',
  AWAITING_FINAL_PAYMENT = 'AWAITING FINAL PAYMENT',
  CANCELLED = 'CANCELLED'
}

export const ALL_VALUATION_STAGES: ValuationStatus[] = [
  ValuationStatus.READY_FOR_ONBOARDING,
  ValuationStatus.ONBOARDING_SENT,
  ValuationStatus.ONBOARDING_FINISHED,
  ValuationStatus.CLIENT_DOCS_RECEIVED,
  ValuationStatus.CLIENT_DOCS_RECEIVED_SKIP_SUPPORT,
  ValuationStatus.CLIENT_DOCS_RECEIVED_ASSIGN_INTERN,
  ValuationStatus.MODEL_DRAFTED,
  ValuationStatus.DRAFT_PREPARED,
  ValuationStatus.DRAFT_REVIEWED_AND_SENT,
  ValuationStatus.CLIENT_APPROVAL_RECEIVED,
  ValuationStatus.REPORT_IN_PROCESS,
  ValuationStatus.FINAL_REPORT_UPLOADED,
  ValuationStatus.FINAL_SENT,
  ValuationStatus.WAITING,
  ValuationStatus.AWAITING_FINAL_PAYMENT,
  ValuationStatus.CANCELLED,
];

export const VALID_CURRENT_VALUATION_STAGES: ValuationStatus[] = ALL_VALUATION_STAGES.filter(
  stage => stage !== ValuationStatus.FINAL_SENT && stage !== ValuationStatus.CANCELLED
);


export const VALID_PAST_VALUATION_STAGES: ValuationStatus[] = ALL_VALUATION_STAGES.filter(
  stage => stage === ValuationStatus.FINAL_SENT || stage === ValuationStatus.CANCELLED
);
